import React, { useState } from 'react'
import { IconButton, useTheme } from '@mui/material'
import { MoreVertical } from 'redesign/components/atoms/Icon'
import ActionWrapper from '../action-wrapper'
import type { MoreButtonProps } from './types'

const MoreButton: React.FC<MoreButtonProps> = ({
  hiddenActions = [],
  icon: Icon = MoreVertical,
  anchorOrigin,
  transformOrigin,
  topMenuMargin,
}) => {
  const { palette } = useTheme()
  const [isOpen, setIsOpen] = useState(false)
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget)
    setIsOpen(true)
  }

  return (
    <ActionWrapper
      isMenuOpen={isOpen}
      setIsMenuOpen={setIsOpen}
      anchorEl={anchorEl}
      hiddenActions={hiddenActions}
      anchorOrigin={anchorOrigin}
      transformOrigin={transformOrigin}
      topMenuMargin={topMenuMargin}
    >
      <IconButton
        data-testid="more-actions-button"
        variant="outlined"
        size="medium"
        color="primary"
        onClick={handleClick}
      >
        <Icon color={palette.primary.main} />
      </IconButton>
    </ActionWrapper>
  )
}

export default MoreButton
